<template>
  <!--<img src="@/assets/images/sv/sv006/main_sp.jpg" class="img-fluid -pcnone" alt="">-->
  <div class="contents-header">
    <div class="img-box">
      <img :src="image_src" class="mainvisual" alt="">
    </div>
    <div class="txt-box">
      <div class="border-box">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'contents-header',
  props: {
    src: {type: String}
  },
  computed: {
    image_src () {
      return require('@/assets/images/sv/' + this.src)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.contents-header {
  position: relative;
  margin-bottom: 50px;
  margin-right: -20px;
  @include mq-up(){
    margin-right: 0px;
  }
  >.txt-box {
    max-width: 79%;
    width: 100%;
    color: #fff;
    padding: 10px;
    position: absolute;
    z-index: 1;
    @include mq-down(){
      top: 50px;
      left: -20px;
    }
    @include mq-up(md) {
      max-width: 600px;
      top: 50%;
      transform: translateY(-50%);
    }
    > .border-box {
      border: 1px solid $white;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 12px;
      @include mq-up(md) {
        padding-left: 28px;
        padding-top: 50px;
        padding-bottom: 50px;
      }
      > .heading1 {
        font-size: 11px;
        line-height: 22px;
        @include mq-up(md) {
          font-size: 22px;
          line-height: 48px;
        }
      }
      > .heading2 {
        font-size: 18px;
        line-height: 25px;
        @include mq-up(md) {
          font-size: 38px;
          line-height: 50px;
        }
      }
    }
  }
  >.img-box {
    text-align: right;
    >.mainvisual{
      width: 100%;
      max-width: 960px;
    }
  }
  &.-blue {
    >.txt-box {
      background-color: rgba($blue, .9);
    }
  }
  &.-green {
    >.txt-box {
      background-color: rgba($green, .9);
    }
  }
  &.-orange {
    >.txt-box {
      background-color: rgba($orange, .9);
    }
  }
}

/*
*/
</style>



// WEBPACK FOOTER //
// src/components/contents/ContentsHeader.vue